import type { ReactNode } from 'react';

export interface EmptyStateProps {
  title: string;
  message?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

export function EmptyState({ title, message, icon, action }: EmptyStateProps): JSX.Element {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'var(--sp-11) var(--sp-10)',
        textAlign: 'center',
        gap: 'var(--sp-6)',
        background: 'var(--surface-card)',
        border: '1px dashed var(--ink-300)',
        borderRadius: 'var(--r-lg)',
        color: 'var(--ink-600)',
      }}
    >
      {icon && <div style={{ fontSize: 28 }}>{icon}</div>}
      <strong style={{ color: 'var(--pcb-blue-dark)', fontSize: 15 }}>{title}</strong>
      {message && <p style={{ margin: 0, fontSize: 13, maxWidth: 480 }}>{message}</p>}
      {action && <div>{action}</div>}
    </div>
  );
}
